var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNotification(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.504,
    height: 22.674
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "002-notification"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 12050"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10374",
    d: "M19.17 15.193L18 14.445V7.95A8.076 8.076 0 0010.5.044a6.208 6.208 0 00-1.5 0A8.076 8.076 0 001.5 7.95v6.494l-1.166.748a.715.715 0 00-.334.6v2.887a.736.736 0 00.75.722h4.945a4.151 4.151 0 008.114 0h4.945a.736.736 0 00.75-.722v-2.886a.715.715 0 00-.334-.6zM9.752 21.23a2.621 2.621 0 01-2.518-1.828h5.037a2.621 2.621 0 01-2.519 1.828zM18 17.958H1.5v-1.779l1.166-.748a.715.715 0 00.334-.6V7.95a6.756 6.756 0 0113.5 0v6.88a.715.715 0 00.334.6l1.166.749z",
    fill: "#001847"
  })))));
}

export default SvgNotification;